import axios from 'axios'

export default function brochureForm() {
	return {
		title: '',
		firstName: '',
		lastName: '',
		email: '',
		phone: '',
		emailPreferred: '',
		phonePreferred: '',
		postPreferred: '',
		message: 'Brochure request',
		consent: false,
		errors: [],
		responseMessage: '',
		selectedDevelopment: '',
		isSubmitting: false,
		redirectUrl: '',

		async submitForm(e) {
			e.preventDefault()

			this.errors = []
			this.responseMessage = ''

			// Validate the fields
			if (!this.title) {
				this.errors.push('Title is required.')
			}

			if (!this.firstName) {
				this.errors.push('First name is required.')
			}

			if (!this.lastName) {
				this.errors.push('Last name is required.')
			}

			if (!this.selectedDevelopment) {
				this.errors.push('Development is required.')
			}

			if (!this.email || !this.isValidEmail(this.email)) {
				this.errors.push('Please enter a valid email address.')
			}

			if (!this.emailPreferred) {
				this.errors.push('Email preference is required')
			}

			if (!this.phonePreferred) {
				this.errors.push('Phone preference is required')
			}

			if (!this.postPreferred) {
				this.errors.push('Post preference is required')
			}

			if (!this.message) {
				this.errors.push('Message is required.')
			}

			if (!this.consent) {
				this.errors.push('You must agree to the Privacy Policy and Cookie Policy.')
			}

			if (this.errors.length) {
				return
			}

			this.isSubmitting = true

			try {
				const form = e.target
				const formData = new FormData(form)

				const response = await axios.post(form.action, formData, {
					headers: {
						'X-Requested-With': 'XMLHttpRequest'
					}
				})

				if (response.data?.errors?.length) {
					this.errors = response.data.errors
					return
				}

				if (response.data?.payload) {
					this.responseMessage = response.data?.message || 'Debug mode: payload shown below.'
					console.log('Contact Builder payload:', response.data.payload)
					this.responseMessage = `${this.responseMessage}\n${JSON.stringify(response.data.payload, null, 2)}`
					return
				}

				this.responseMessage = response.data?.message || 'Your form submission has been sent!'
				this.clearForm()

				setTimeout(() => {
					if (document.querySelector('.brochure-selected a') !== null) {
						document.querySelector('.brochure-selected a').click()
					} else {
						this.redirectUrl = this.redirectUrl + '?brochureUnavailable=true'
					}

					setTimeout(() => {
						this.redirect()
					}, 1250)
				}, 500)

			} catch (error) {
				const data = error.response?.data || {}
				this.errors = data.errors || []
				this.responseMessage = data.message || 'Something went wrong when submitting your message.'
			} finally {
				this.isSubmitting = false
			}
		},

		// Clear the form after submission
		clearForm() {
			this.title = ''
			this.firstName = ''
			this.lastName = ''
			this.email = ''
			this.phone = ''
			this.emailPreferred = ''
			this.phonePreferred = ''
			this.postPreferred = ''
			this.message = 'Brochure request'
			this.consent = false
		},

		redirect() {
			window.location.href = this.redirectUrl
		},

		isValidEmail(email) {
			const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
			return emailPattern.test(email)
		}
	}
}
